var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { UIForm, UIModal, UIModalContent, UIModalFooter, UIModalHeader, } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import FormInputItem from './FormInputItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RenameObjectModal',
    setup(__props) {
        const open = ref(false);
        const emitter = useEmitter();
        const selectedObj = ref();
        const processing = ref(false);
        const store = useStore();
        const formValue = ref({ name: '' });
        const { sendNotification } = useEvent();
        const formRef = ref(null);
        const { t } = useI18n();
        const rules = {
            name: {
                required: true,
                validator: (_, value) => {
                    var _a;
                    if (!value.trim()) {
                        return new Error(((_a = selectedObj.value) === null || _a === void 0 ? void 0 : _a.type) === 'folder'
                            ? t('common.folderNameValidation')
                            : t('common.fileNameValidation'));
                    }
                    return Boolean(value);
                },
                trigger: ['input', 'blur'],
            },
        };
        const saveFolder = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (selectedObj.value) {
                try {
                    processing.value = true;
                    yield ((_b = (_a = formRef.value) === null || _a === void 0 ? void 0 : _a.getForm()) === null || _b === void 0 ? void 0 : _b.validate());
                    yield MediaService.renameObject({
                        id: (_c = selectedObj.value) === null || _c === void 0 ? void 0 : _c._id,
                        name: formValue.value.name.trim(),
                        altId: store.altId,
                        altType: store.altType,
                    });
                    processing.value = false;
                    open.value = false;
                    sendNotification({
                        type: 'success',
                        title: selectedObj.value.type === 'file'
                            ? t('common.fileUpdated')
                            : t('common.folderUpdated'),
                        description: `${formValue.value.name} ${t('common.hasBeenUpdated')}`,
                    });
                    emitter.emit('updateUI');
                }
                catch (error) {
                    processing.value = false;
                    console.error(error);
                }
            }
        });
        emitter.on('renameObject', (item) => {
            open.value = true;
            selectedObj.value = item;
            formValue.value.name = item.name;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: open.value,
                id: "modal"
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "modal-header",
                        type: "primary",
                        title: _ctx.$t('common.rename'),
                        onClose: _cache[0] || (_cache[0] = ($event) => (open.value = false))
                    }, null, 8 /* PROPS */, ["title"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('common.save'),
                        negativeText: _ctx.$t('common.cancel'),
                        onPositiveClick: saveFolder,
                        onNegativeClick: _cache[2] || (_cache[2] = ($event) => (open.value = false)),
                        id: "modal-footer",
                        loading: processing.value,
                        disabled: processing.value
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIForm), {
                                model: formValue.value,
                                rules: rules,
                                ref_key: "formRef",
                                ref: formRef,
                                id: "modal-form"
                            }, {
                                default: _withCtx(() => {
                                    var _a, _b;
                                    return [
                                        _createVNode(FormInputItem, {
                                            modelValue: formValue.value.name,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formValue.value.name) = $event)),
                                            itemPlaceholder: ((_a = selectedObj.value) === null || _a === void 0 ? void 0 : _a.type) === 'folder'
                                                ? _ctx.$t('common.folderNameValidation')
                                                : _ctx.$t('common.fileNameValidation'),
                                            itemId: "name",
                                            itemLabel: ((_b = selectedObj.value) === null || _b === void 0 ? void 0 : _b.type) === 'folder'
                                                ? _ctx.$t('common.folderName')
                                                : _ctx.$t('common.fileName')
                                        }, null, 8 /* PROPS */, ["modelValue", "itemPlaceholder", "itemLabel"])
                                    ];
                                }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["model"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
